import {useListView} from '../../core/ListViewProvider'
import {CiapListToolbar} from './CiapListToolbar'
import {SitesListGrouping} from './SitesListGrouping'

const CiapListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
   
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        <CiapListToolbar />
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {CiapListHeader}
